import { getLogger } from 'app-components/utils/core';
import store from 'app-components/utils/redux-store';
import { navigate } from 'NavigateSetter';

import { getNavigationIntent, isNavigationIntentAvailable } from './registry';
import type { NavigationResult } from './types';

const log = getLogger('navigationExecutor');

export const executeNavigationIntent = async (
  intentName: string,
  args?: Record<string, unknown>,
): Promise<NavigationResult> => {
  const intent = getNavigationIntent(intentName);
  if (!intent) {
    return { type: 'error', reason: `Unknown navigation intent: ${intentName}` };
  }

  if (!store) {
    return { type: 'error', reason: 'Navigation unavailable: store not initialized' };
  }

  if (!isNavigationIntentAvailable(intent, store.getState())) {
    return { type: 'error', reason: `The ${intentName} feature is not available for this account.` };
  }

  try {
    const result = await intent.resolver(args, store.getState());
    if (result.type === 'navigate') {
      const { path, state } = result.payload;
      if (state === undefined) {
        navigate(path);
      } else {
        navigate(path, { state });
      }
    }
    return result;
  } catch (error) {
    log.error('Navigation intent failed', { intentName, error });
    return { type: 'error', reason: 'Failed to execute navigation intent' };
  }
};
